import React from "react";
import {BaseComponent, IBaseComponentProps, ReactUtility} from "@reapptor-apps/reapptor-react-common";
import {
    Carousel,
    CarouselNavigation,
    CarouselPagination,
    Icon,
    IconSize,
    Modal
} from "@reapptor-apps/reapptor-react-components"
import Localizer from "@/localization/Localizer";

import styles from "./HdsModal.module.scss";

import slide0 from "./slides/slide_0.jpg";
import slide1 from "./slides/slide_1.jpg";
import slide2 from "./slides/slide_2.jpg";
import slide3 from "./slides/slide_3.jpg";
import slide3N from "./slides/slide_3N.jpeg";
import slide4 from "./slides/slide_4.jpg";
import slide4N from "./slides/slide_4N.png";
import slide5 from "./slides/slide_5.jpg";
import slide6 from "./slides/slide_6.jpg";
import slide6N from "./slides/slide_6N.webp";
import slide7 from "./slides/slide_7.jpg";
import slide8 from "./slides/slide_8.jpg";
import slide8N from "./slides/slide_8N.jpg";
import slide10N from "./slides/slide_10N.webp";

const slides = [
    //Offer
    {
        tabIndex: 0,
        image: slide0,
        title: Localizer.hdsModalSlide0TitleLanguageItemName,
        description: Localizer.hdsModalSlide0DescriptionLanguageItemName,
        copyright: "destination.hauts-de-seine.fr",
        offer: false,
    },
    
    //Boulogne-Billancourt
    {
        //1. Musée Paul Landowski
        tabIndex: 1,
        image: slide4N,
        title: Localizer.hdsModalSlide4NTitleLanguageItemName,
        description: Localizer.hdsModalSlide4NDescriptionLanguageItemName,
        copyright: "© CD92 Willy Labre",
        offer: Localizer.hdsModalDiscount1LanguageItemName,
    },
    {
        //2. Musée Belmondo
        tabIndex: 1,
        image: slide3N,
        title: Localizer.hdsModalSlide3NTitleLanguageItemName,
        description: Localizer.hdsModalSlide3NDescriptionLanguageItemName,
        copyright: "© CD92",
        offer: Localizer.hdsModalDiscount1LanguageItemName,
    },
    {
        //3. Le musée des Années 30 *
        tabIndex: 1,
        image: slide8,
        title: Localizer.hdsModalSlide8TitleLanguageItemName,
        description: Localizer.hdsModalSlide8DescriptionLanguageItemName,
        copyright: "© CD92 Willy Labre",
        offer: Localizer.hdsModalDiscount1LanguageItemName,
    },
    {
        //4. La Seine Musicale
        tabIndex: 1,
        image: slide6,
        title: Localizer.hdsModalSlide6TitleLanguageItemName,
        description: Localizer.hdsModalSlide6DescriptionLanguageItemName,
        copyright: "© CD92 Willy Labre",
        offer: false,
    },
    {
        //5. Office de tourisme de Boulogne-Billancourt
        tabIndex: 1,
        image: slide6N,
        title: Localizer.hdsModalSlide6NTitleLanguageItemName,
        description: Localizer.hdsModalSlide6NDescriptionLanguageItemName,
        copyright: "© Alain de Baudus",
        offer: Localizer.hdsModalDiscount2LanguageItemName,
    },
    {
        //6. Musée départemental Albert-Kahn
        tabIndex: 1,
        image: slide7,
        title: Localizer.hdsModalSlide7TitleLanguageItemName,
        description: Localizer.hdsModalSlide7DescriptionLanguageItemName,
        copyright: "© Alain de Baudus",
        offer: Localizer.hdsModalDiscount1LanguageItemName,
    },

    //L’escale de Sèvres
    {
        //7. Le Jardin des métiers d’Art et du Design et la Cité de la Céramique à Sèvres
        tabIndex: 2,
        image: slide3,
        title: Localizer.hdsModalSlide3TitleLanguageItemName,
        description: Localizer.hdsModalSlide3DescriptionLanguageItemName,
        copyright: "© CD92 Julia Brechle",
        offer: false,
    },
    {
        //8. Le Domaine national de Saint-Cloud
        tabIndex: 2,
        image: slide4,
        title: Localizer.hdsModalSlide4TitleLanguageItemName,
        description: Localizer.hdsModalSlide4DescriptionLanguageItemName,
        copyright: "© CD92 Willy Labre",
        offer: Localizer.hdsModalDiscount3LanguageItemName,
    },
    {
        //9. La base nautique départementale de L’Ile de Monsieur
        tabIndex: 2,
        image: slide5,
        title: Localizer.hdsModalSlide5TitleLanguageItemName,
        description: Localizer.hdsModalSlide5DescriptionLanguageItemName,
        copyright: "© CD92 Stephanie Gutierrez-Ortega",
        offer: false,
    },
    {
        //10. Manufacture et Musée nationaux de Sèvres
        tabIndex: 2,
        image: slide10N,
        title: Localizer.hdsModalSlide10NTitleLanguageItemName,
        description: Localizer.hdsModalSlide10NDescriptionLanguageItemName,
        copyright: "© CD92 Willy Labre",
        offer: Localizer.hdsModalDiscount1LanguageItemName,
    },
    
    //l’escale d’Issy-les-Moulineaux
    {
        //11. Le parc départemental de l’Île Saint-Germain et la Tour aux Figures de Jean Dubuffet
        tabIndex: 3,
        image: slide1,
        title: Localizer.hdsModalSlide1TitleLanguageItemName,
        description: Localizer.hdsModalSlide1DescriptionLanguageItemName,
        copyright: "© CD92 Stephanie Gutierrez-Ortega",
        offer: Localizer.hdsModalDiscount4LanguageItemName,
    },
    {
        //12. Les Halles Biltoki
        tabIndex: 3,
        image: slide2,
        title: Localizer.hdsModalSlide2TitleLanguageItemName,
        description: Localizer.hdsModalSlide2DescriptionLanguageItemName,
        copyright: "© CD92 Olivier Ravoire",
        offer: false,
    },
    {
        //13. Issy Tourisme International
        tabIndex: 3,
        image: slide8N,
        title: Localizer.hdsModalSlide8NTitleLanguageItemName,
        description: Localizer.hdsModalSlide8NDescriptionLanguageItemName,
        copyright: "© Issy Tourisme International",
        offer: Localizer.hdsModalDiscount5LanguageItemName,
    },
];

interface IHdsModalProps extends IBaseComponentProps {
}

interface IHdsModalState {
    //slideIndex: number;
}

export default class HdsModal extends BaseComponent<IHdsModalProps, IHdsModalState> {

    state: IHdsModalState = {
        //slideIndex: 0,
    }

    private readonly _modalRef: React.RefObject<Modal> = React.createRef();
    private readonly _carouselRef: React.RefObject<Carousel> = React.createRef();
    
    private async onSlideChangeAsync(index: number): Promise<void> {
        await this.reRenderAsync();
    }
    
    private async selectTabIndexAsync(tabIndex: number): Promise<void> {
        const slide = slides.first(item => item.tabIndex == tabIndex);
        
        const slideIndex: number = slides.indexOf(slide);

        await this._carouselRef.current?.slideToAsync(slideIndex);
    }

    private async nextSlideAsync(): Promise<void> {
        if (this._carouselRef.current) {
            await this._carouselRef.current.slideNextAsync();
        }
    }
    
    private async onCloseAsync(): Promise<void> {
        await this.modal?.closeAsync();
    }

    private get modal(): Modal {
        return this._modalRef.current!;
    }
    
    private get slideIndex(): number {
        return this._carouselRef.current?.currentSlideIndex ?? 0;
    }
    
    private get tabIndex(): number {
        return slides[this.slideIndex].tabIndex;
    }
    
    private get title(): string {
        return slides[this.slideIndex].title;
    }
    
    private get copyright(): string {
        return slides[this.slideIndex].copyright;
    }
    
    private get offer(): string | boolean {
        return slides[this.slideIndex].offer;
    }
    
    private get description(): string {
        return slides[this.slideIndex].description;
    }

    public async openAsync(animation: boolean = true): Promise<void> {
        await this.modal.openAsync(animation);
        await this.reRenderAsync();
    }

    public get isOpen(): boolean {
        return (this._modalRef.current != null) && (this._modalRef.current.isOpen);
    }
    
    private renderImage(image: string, index: number = 0): React.ReactElement {
        return (
            <div key={index}
                 className={styles.image}
            >
                <img alt={""}
                     //loading="lazy"
                     src={image}
                />
                <span className={styles.copyright}>{this.copyright}</span>
            </div>
        );
    }

    public render(): React.ReactNode {
        const tabIndex: number = this.tabIndex;
        
        return (
            <Modal noHeader
                   id={this.id}
                   ref={this._modalRef}
                   className={this.css(styles.hdsModal, this.props.className)}
                   onClose={() => this.onCloseAsync()}
            >

                {
                    (this.isOpen) &&
                    (
                        <div className={styles.container}>

                            <div className={styles.toolbar}>

                                <Icon name={"fal fa-times-circle"} onClick={() => this.onCloseAsync()}/>

                            </div>

                            <div className={styles.content}>

                                <div className={styles.navigation}>
                                    <span className={this.css(((tabIndex == 0) && styles.active))}
                                          onClick={() => this.selectTabIndexAsync(0)}
                                    >
                                        <Icon name={"fal fa-landmark-alt"}
                                              size={IconSize.Large}
                                        />
                                    </span>
                                    <span className={this.css(((tabIndex == 1) && styles.active))}
                                          onClick={() => this.selectTabIndexAsync(1)}
                                    >
                                        Boulogne-Billancourt
                                    </span>
                                    <span className={this.css(((tabIndex == 2) && styles.active))}
                                          onClick={() => this.selectTabIndexAsync(2)}
                                    >
                                        L’escale de Sèvres
                                    </span>
                                    <span className={this.css(((tabIndex == 3) && styles.active))}
                                          onClick={() => this.selectTabIndexAsync(3)}
                                    >
                                        Issy-les-Moulineaux
                                    </span>
                                </div>

                                <div className={styles.images}>

                                    <Carousel ref={this._carouselRef}
                                              navigation={CarouselNavigation.Inside}
                                              pagination={CarouselPagination.BottomOutside}
                                              slidesPerView={1}
                                              className={this.css(styles.carousel, styles.thumbnail)}
                                              onSlideChange={(index) => this.onSlideChangeAsync(index)}
                                    >

                                        {
                                            slides.map((slide, index) => this.renderImage(slide.image, index))
                                        }

                                    </Carousel>

                                </div>

                                <span className={styles.title}>{Localizer.get(this.title)}</span>

                                <div className={styles.description} onClick={() => this.nextSlideAsync()}>

                                    <span>{ReactUtility.toMultiLines(Localizer.get(this.description))}</span>

                                    {
                                        ((this.offer) && (typeof this.offer === "string")) &&
                                        (
                                            <span className={styles.message}>{ReactUtility.toMultiLines(Localizer.get(this.offer))}</span>
                                        )
                                    }

                                </div>

                            </div>

                        </div>
                    )
                }

            </Modal>
        )
    }
}